import MetaTag from "components/Common/Meta-tag"
import React, { useEffect, useState } from "react"
import { Badge, Button, Card, Col, Container, Row } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import moment from "moment"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useParams } from "react-router-dom"
import { FaUserSecret, FaSearch } from "react-icons/fa" // Import this at the top
import {
  getInspectionBookingDetails,
  putWhatsappShare,
  // putWhatsappSharePdf,
} from "store/actions"
import { FaWhatsapp } from "react-icons/fa"

function InspectionBookingDetails() {
  const history = useHistory()
  const dispatch = useDispatch()
  const params = useParams()
  const [isLoading, setIsLoading] = useState(false)

  const {  inspectionBookingDetails } = useSelector(state => ({
    inspectionBookingDetails: state.Inspection?.inspectionBookingDetails,
  }))


  useEffect(() => {
    dispatch(getInspectionBookingDetails(params.id))
  }, [params.id])

  const handleRouteCreate = () => {
    history.push("/inspection/create", {
      bookingNo: inspectionBookingDetails?.booking_id,
      phone: inspectionBookingDetails?.user_details?.phone,
      name: inspectionBookingDetails?.user_details?.name,
    })
  }

  const getStatusColor = status => {
    switch (status) {
      case "NEW":
        return "primary"
      case "PENDING":
        return "warning"
      case "PROCESSING":
        return "secondary"
      case "COMPLETED":
        return "success"
      default:
        return "light" // fallback
    }
  }
  const formatStatusLabel = status => {
    return status
      ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
      : "-"
  }
  return (
    <div>
      <MetaTag title={"Inspection Booking Details"} />
      <div className="page-content">
        <Breadcrumbs title="Dashboard" breadcrumbItem="Booking Details" />
        <Card>
          <Container fluid className="p-3">
            <Row className="my-3">
              <Col md="4">
                <div>
                  <span className="dark-grey fw-light">Booking ID </span>
                </div>
                <div className=" grey-color">
                  {inspectionBookingDetails?.booking_id || "--"}
                </div>{" "}
              </Col>
              {inspectionBookingDetails?.inspection?.is_completed ? (
                <>
                  <Col md="4">
                    <div>
                      <span className="dark-grey fw-light">Inspection Id </span>
                    </div>
                    <div className=" grey-color">
                      {
                        inspectionBookingDetails?.inspection
                          ?.inspection_document
                      }{" "}
                    </div>{" "}
                  </Col>
                  <Col md="4">
                    <div>
                      <span className="dark-grey fw-light">Status </span>
                    </div>
                    <div className=" grey-color">
                      {/* {inspectionBookingDetails?.inspection?.is_completed
                        ? "Completed"
                        : "In Progress"} */}
                      <Badge
                        style={{
                          textTransform: "capitalize",
                          fontSize: "12px",
                          padding: "4px 8px",
                        }}
                        className={
                          "px-2 py-1 badge-soft-" +
                          (inspectionBookingDetails?.inspection?.is_completed
                            ? "success"
                            : "warning")
                        }
                      >
                        {inspectionBookingDetails?.inspection?.is_completed ===
                        true
                          ? "Completed"
                          : inspectionBookingDetails?.inspection
                              ?.is_completed === false
                          ? "In Progress"
                          : "--"}
                      </Badge>
                    </div>{" "}
                  </Col>
                </>
              ) : (
                <Col md="8" className="d-flex justify-content-end">
                  <Button
                    color="warning"
                    className="px-3 py-1 btn-rounded d-flex align-items-center"
                    onClick={handleRouteCreate}
                    style={{ width: "fit-content" }}
                  >
                    <span
                      style={{
                        position: "relative",
                        marginRight: "8px",
                        width: "20px",
                        height: "20px",
                      }}
                    >
                      <FaUserSecret
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          fontSize: "16px",
                        }}
                      />
                      <FaSearch
                        style={{
                          position: "absolute",
                          bottom: 0,
                          right: -4,
                          fontSize: "10px",
                        }}
                      />
                    </span>
                    Inspect Car
                  </Button>
                </Col>
              )}
            </Row>
            <Row className="bg-light px-1 mt-3 py-2 mb-1 heading-document">
              <Col>
                <span>USER DETAILS</span>
              </Col>
            </Row>
            <Row className="my-3">
              <Col md="3">
                <div>
                  <span className="dark-grey fw-light">Name </span>
                </div>
                <div className=" grey-color">
                  {inspectionBookingDetails?.user_details?.name || "--"}
                </div>{" "}
              </Col>
              <Col md="3">
                <div>
                  <span className="dark-grey fw-light">Phone </span>
                </div>
                <div className=" grey-color">
                  {inspectionBookingDetails?.user_details?.phone
                    ? inspectionBookingDetails.user_details.country_code
                      ? `${inspectionBookingDetails.user_details.country_code}-${inspectionBookingDetails.user_details.phone}`
                      : inspectionBookingDetails.user_details.phone
                    : "--"}
                </div>{" "}
              </Col>
              <Col md="3">
                <div>
                  <span className="dark-grey fw-light">WhatsApp </span>
                </div>
                <div className=" grey-color">
                  {inspectionBookingDetails?.user_details?.whatsapp
                    ? inspectionBookingDetails.user_details
                        .whatsapp_country_code
                      ? `${inspectionBookingDetails.user_details.whatsapp_country_code}-${inspectionBookingDetails.user_details.whatsapp}`
                      : inspectionBookingDetails.user_details.whatsapp
                    : "--"}
                </div>{" "}
              </Col>
              <Col md="3">
                <div>
                  <span className="dark-grey fw-light">State </span>
                </div>
                <div className=" grey-color">
                  {inspectionBookingDetails?.user_details?.state?.name || "---"}
                </div>{" "}
              </Col>
            </Row>
            <Row className="my-3">
              <Col md="3">
                <div>
                  <span className="dark-grey fw-light">District </span>
                </div>
                <div className=" grey-color">
                  {inspectionBookingDetails?.user_details?.district?.name ||
                    "---"}
                </div>{" "}
              </Col>
              <Col md="3">
                <div>
                  <span className="dark-grey fw-light">City </span>
                </div>
                <div className=" grey-color">
                  {inspectionBookingDetails?.user_details?.city || "---"}
                </div>{" "}
              </Col>
              <Col md="3">
                <div>
                  <span className="dark-grey fw-light">Pin code </span>
                </div>
                <div className=" grey-color">
                  {inspectionBookingDetails?.user_details?.pincode || "---"}
                </div>{" "}
              </Col>
              <Col md="3">
                <div>
                  <span className="dark-grey fw-light">Address </span>
                </div>
                <div className=" grey-color">
                  {inspectionBookingDetails?.user_details?.address || "---"}{" "}
                </div>{" "}
              </Col>
            </Row>

            <Row className="bg-light px-1 mt-3 py-2 mb-1 heading-document">
              <Col>
                <span>PAYMENT DETAILS</span>
              </Col>
            </Row>
            <Row className="my-3">
              <Col md="3">
                <div>
                  <span className="dark-grey fw-light">Brand </span>
                </div>
                <div className=" grey-color">
                  {inspectionBookingDetails?.vehicle_details?.brand?.name ||
                    "---"}
                </div>{" "}
              </Col>
              <Col md="9">
                <Row>
                  <Col md="3">
                    <div>
                      <span className="dark-grey fw-light">Amount </span>
                    </div>
                    <div className=" grey-color">
                      {inspectionBookingDetails?.vehicle_details?.brand
                        ?.inspection_charge?.price != null
                        ? inspectionBookingDetails.vehicle_details.brand
                            .inspection_charge.offer_price ??
                          inspectionBookingDetails.vehicle_details.brand
                            .inspection_charge.price
                        : "---"}
                    </div>
                  </Col>
                  <Col md="3">
                    <div>
                      <span className="dark-grey fw-light">Paid on </span>
                    </div>
                    <div className=" grey-color">
                      {" "}
                      {inspectionBookingDetails?.payment_status?.paid_at
                        ? moment
                            .utc(
                              inspectionBookingDetails.payment_status.paid_at
                            )
                            .format("DD/MM/YYYY")
                        : " ---"}
                    </div>{" "}
                  </Col>
                  <Col md="3">
                    <div>
                      <span className="dark-grey fw-light">Payment Type </span>
                    </div>
                    <div className=" grey-color">
                      {" "}
                      <Badge
                        style={{
                          textTransform: "capitalize",
                          fontSize: "12px",
                          padding: "4px 8px !important",
                        }}
                        className={
                          "px-2 py-1 badge-soft-" +
                          (inspectionBookingDetails?.payment_type ===
                          "PAY_LATER"
                            ? "success"
                            : inspectionBookingDetails?.payment_type ===
                              "ONLINE"
                            ? "info"
                            : "secondary")
                        }
                      >
                        {inspectionBookingDetails?.payment_type === "PAY_LATER"
                          ? "Pay later"
                          : inspectionBookingDetails?.payment_type === "ONLINE"
                          ? "Online"
                          : "-"}
                      </Badge>
                    </div>{" "}
                  </Col>
                  <Col md="3">
                    <div>
                      <span className="dark-grey fw-light">
                        Payment Status{" "}
                      </span>
                    </div>
                    <div className=" grey-color">
                      {" "}
                      <Badge
                        style={{
                          textTransform: "capitalize",
                          fontSize: "12px",
                          padding: "4px 8px !important",
                        }}
                        className={
                          "px-2 py-1 badge-soft-" +
                          (inspectionBookingDetails?.payment_status?.is_paid ===
                          true
                            ? "success"
                            : inspectionBookingDetails?.payment_status
                                ?.is_paid === false
                            ? "info"
                            : "secondary")
                        }
                      >
                        {inspectionBookingDetails?.payment_status?.is_paid ===
                        true
                          ? "Paid"
                          : inspectionBookingDetails?.payment_status
                              ?.is_paid === false
                          ? "Unpaid"
                          : "-"}
                      </Badge>
                    </div>{" "}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="bg-light px-1 mt-3 py-2 mb-1 heading-document">
              <Col>
                <span>BOOKING STATUS</span>
              </Col>
            </Row>
            <Row className="my-3">
              <Col md="4">
                <div>
                  <span className="dark-grey fw-light">Booking Status </span>
                </div>
                <div className=" grey-color">
                  {" "}
                  <Badge
                    className={`font-size-12 badge-soft-${getStatusColor(
                      inspectionBookingDetails?.booking_status
                    )} me-2 mt-1`}
                    color=""
                    pill
                  >
                    {formatStatusLabel(
                      inspectionBookingDetails?.booking_status
                    )}
                  </Badge>
                </div>{" "}
              </Col>{" "}
              {inspectionBookingDetails?.note && (
                <Col md="8">
                  <div>
                    <span className="dark-grey fw-light">Note </span>
                  </div>
                  <div className=" grey-color">
                    {inspectionBookingDetails?.note || "---"}
                  </div>{" "}
                  {/* <textarea
                    className="form-control"
                    rows={1}
                    placeholder="Enter Details"
                    readOnly
                    defaultValue={inspectionBookingDetails?.note || "---"}
                    // defaultValue={inspectionBookingDetails?.note || ""}
                    style={{
                      borderRadius: "2px",
                      fontSize: "14px",
                      padding: "10px",
                      color: "#6c757d",
                      resize: "none",
                      backgroundColor: "#fff",
                      cursor: "default",
                      borderColor: "#919EAB33",
                      borderWidth: "1px",
                      borderStyle: "solid",
                    }}
                  />{" "} */}
                </Col>
              )}
            </Row>
            <Row className="justify-content-end ">
              <Col md="auto" className="d-flex flex-column align-items-center">
                <span
                  onClick={() =>
                    dispatch(putWhatsappShare(params.id, setIsLoading))
                  }
                  style={{
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#007bff", // Bootstrap primary blue
                    textDecoration: "underline",
                  }}
                >
                  {" "}
                  <FaWhatsapp
                    style={{
                      fontSize: "14px",
                      marginRight: "5px",
                      color: "green",
                    }}
                  />
                  {isLoading ? "Sending..." : "Resend Notification"}
                </span>
                <div style={{ textAlign: "center", marginTop: 6 }}>
                  {inspectionBookingDetails?.last_sent_at_whatsapp ? (
                    <span
                      style={{
                        color: "grey",
                        fontWeight: 500,
                        fontSize: "12px",
                      }}
                    >
                      Last shared on{" "}
                      {moment(
                        inspectionBookingDetails.last_sent_at_whatsapp
                      ).format("DD/MM/YYYY HH:mm")}
                    </span>
                  ) : (
                    <span
                      style={{
                        color: "#dc3545",
                        fontWeight: 500,
                        fontSize: "12px",
                      }}
                    >
                      Not shared with client
                    </span>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </Card>
      </div>
    </div>
  )
}

export default InspectionBookingDetails
